<template>
  <b-modal
    :visible="value"
    @change="$emit('input', $event)"
    title="Email Preview"
    size="xl"
    hide-footer
    body-class="p-0"
  >
    <iframe
      v-if="html"
      ref="previewFrame"
      class="preview-iframe"
      sandbox="allow-same-origin"
      :srcdoc="html"
    />
    <div v-else class="text-center py-5 text-muted">
      No preview available.
    </div>
  </b-modal>
</template>

<script>
export default {
  name: 'TemplatePreviewModal',
  props: {
    value: { type: Boolean, default: false },
    html: { type: String, default: '' },
  },
};
</script>

<style scoped>
.preview-iframe {
  width: 100%;
  height: 70vh;
  border: none;
}
</style>
